// ABOUTME: Tells a starved-for-DATA element from a wedged DECODER and un-wedges the latter with a half-frame seek.
// ABOUTME: Pure helpers, no React: the player calls them from its stall ladder (useVideoPlayer.js).

// Measured 2026-10-07 on the owner's laptop: `waiting` with 12.6 s buffered ahead, readyState 2, playhead stuck, 44 frames decoded in all.
// Data was there; the browser's decode/render pipeline had stopped pulling frames (GPU contention), and an element left playing never
// resumed. Easing the playback rate cannot help that (it is not a bandwidth problem); a seek flushes the pipeline.
export const WEDGE_MIN_AHEAD_S = 0.75;

/** Seconds of media buffered ahead of the playhead (0 when the playhead is not inside a buffered range). */
export function bufferAhead(v) {
  const b = v.buffered;
  for (let i = 0; i < (b ? b.length : 0); i += 1) {
    if (v.currentTime >= b.start(i) - 0.05 && v.currentTime <= b.end(i)) return Math.max(0, b.end(i) - v.currentTime);
  }
  return 0;
}

/** Playing, no frame ready for the next tick, yet the data is already buffered: the decoder, not the network. */
export function isDecoderWedge(v) {
  return !v.paused && v.readyState <= 2 && bufferAhead(v) >= WEDGE_MIN_AHEAD_S;
}

/**
 * Nudge the playhead half a frame forward (clamped inside the segment): the half-frame landing is the one the loop wrap already uses,
 * so it shows the intended frame, and the seek flushes the decoder pipeline.
 * @returns {number} the time seeked to
 */
export function kickDecoder(v, seg, fps = 30) {
  const half = 1 / (2 * fps);
  const lo = Number.isFinite(seg?.start) ? seg.start : 0;
  const hi = Number.isFinite(seg?.end) ? seg.end - half : Infinity;
  const target = Math.min(Math.max(v.currentTime + half, lo), hi);
  v.currentTime = target;
  return target;
}
